/**
 * Environment configuration with safe defaults
 * All URLs and sensitive config should be pulled from here
 */

// Application URLs
export const APP_BASE_URL = process.env.REACT_APP_BASE_URL || 'songaday-net-dev.firebaseapp.com';
export const SONG_SHARE_URL = process.env.REACT_APP_SONG_SHARE_URL || 'songaday-net-dev.firebaseapp.com';

// App Configuration
export const APP_TITLE = process.env.REACT_APP_TITLE || 'Song Share';
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || 'hi@schoolofsong.org';

// Helper for referencing icons in /public/assets/icon/. The actual icon
// files are swapped per Firebase Hosting target by scripts/stage-instance.js,
// which overlays config/instances/<name>/public over ./public at build time.
export const iconUrl = (filename: string): string =>
  `/assets/icon/${filename.replace(/^\//, '')}`;

// Feature Flags
// Set to 'true' for educational sites with groups/assignments, 'false' for pure social network
export const ENABLE_GROUPS = process.env.REACT_APP_ENABLE_GROUPS?.toLowerCase() !== 'false';
// Set to 'true' to enable magic link (email) login alongside Google sign-in
export const ENABLE_MAGIC_LINK = process.env.REACT_APP_ENABLE_MAGIC_LINK?.toLowerCase() === 'true';
// Set to 'true' to show the Support/Donate page in the menu
export const ENABLE_SUPPORT = process.env.REACT_APP_ENABLE_SUPPORT?.toLowerCase() === 'true';

// Search Indexes (Algolia)
// Defaults match the repo-default songaday-net instance. Other instances set
// REACT_APP_ARTIST_INDEX / REACT_APP_SONG_INDEX in their config/instances/<n>/env.
export const ARTIST_INDEX = process.env.REACT_APP_ARTIST_INDEX || 'artist-song-share';
export const SONG_INDEX = process.env.REACT_APP_SONG_INDEX || 'song-share';

// Firebase Configuration
// Reads from REACT_APP_FIREBASE_* env vars set per deployment target.
// Defaults to songaday-net-dev for safety if no .env target is loaded.
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyDTmm_e8foz5G8TwXqivlqhg5e0KNiqv0g',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'songaday-net-dev.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'songaday-net-dev',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'songaday-net-dev.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '896039456820',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:896039456820:web:b34cc2528839367df5fa61',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// AWS S3 Configuration
export const s3Config = {
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID || 'AKIA2OEWYLRN65ROYYNH',
  bucketUrl: process.env.REACT_APP_S3_BUCKET_URL || 'https://songadays.s3.amazonaws.com',
  policy: process.env.REACT_APP_S3_POLICY || 'ewogICJleHBpcmF0aW9uIjogIjIwMjYtMTEtMTFUMDA6MDA6MDBaIiwKICAiY29uZGl0aW9ucyI6IFsKICAgIHsiYnVja2V0IjogInNvbmdhZGF5cyJ9LAogICAgWyJzdGFydHMtd2l0aCIsICIka2V5IiwgIiJdLAogICAgeyJhY2wiOiAicHJpdmF0ZSJ9LAogICAgWyJzdGFydHMtd2l0aCIsICIkQ29udGVudC1UeXBlIiwgIiJdLAogICAgWyJzdGFydHMtd2l0aCIsICIkZmlsZW5hbWUiLCAiIl0sCiAgICBbImNvbnRlbnQtbGVuZ3RoLXJhbmdlIiwgMCwgNTI0Mjg4MDAwXQogIF0KfQ==',
  signature: process.env.REACT_APP_S3_SIGNATURE || 'Hj/byeDzXjdqDXxDlU9JHcpGVFQ=',
};

// Helper to get the base URL without trailing slash
export const getBaseUrl = (): string => APP_BASE_URL.replace(/\/$/, '');

// Helper to construct full URLs
export const buildUrl = (path: string): string => {
  const base = getBaseUrl();
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
};
